import React from 'react';
import { FadeInDirectionType, FadeWrapper } from '../../../component/animation/animationWrapper';
import { useMobile } from '../../../hook/usePlatform';

const ManagerPhoto : React.FC = () => {
  const isMobile = useMobile();
  return (
    <div style={{ flex: 1 }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        paddingBlock: isMobile ? 30 : 160,
        paddingInline: isMobile ? 30 : 120,
      }}
      >
        <FadeWrapper
          direction={FadeInDirectionType.rtl}
          fadeInDistance={10}
          duration={1.5}
        >
          <img
            alt="manager"
            style={{ width: '100%' }}
            src="/image/manager.png"
          />
        </FadeWrapper>
      </div>
    </div>
  );
};

export default ManagerPhoto;
